import { useState, useEffect, useCallback } from 'react';
import ProspectStatsStrip from '../../components/prospects/ProspectStatsStrip/ProspectStatsStrip';
import ProspectNavPanel from '../../components/prospects/ProspectNavPanel/ProspectNavPanel';
import ProspectWorkspace from '../../components/prospects/ProspectWorkspace/ProspectWorkspace';
import { getAllProspects, getProspectStats } from '../../api/prospectApi';
import './ProspectsPage.css';

export default function ProspectsPage() {
  const [prospects, setProspects] = useState([]);
  const [stats, setStats] = useState(null);
  const [loadingProspects, setLoadingProspects] = useState(true);
  const [loadingStats, setLoadingStats] = useState(true);
  const [selectedProspect, setSelectedProspect] = useState(null);
  const [activeFilter, setActiveFilter] = useState('ALL');

  const loadProspects = useCallback(async () => {
    try {
      const data = await getAllProspects();
      setProspects(data);
    } catch (ex) {
      console.error('Failed to load prospects:', ex);
    } finally {
      setLoadingProspects(false);
    }
  }, []);

  const loadStats = useCallback(async () => {
    try {
      const data = await getProspectStats();
      setStats(data);
    } catch (ex) {
      console.error('Failed to load prospect stats:', ex);
    } finally {
      setLoadingStats(false);
    }
  }, []);

  useEffect(() => {
    loadProspects();
    loadStats();
  }, [loadProspects, loadStats]);

  function handleFilterChange(filterKey) {
    setActiveFilter(filterKey);
  }

  function handleTileClick(filterKey) {
    if (activeFilter === filterKey) {
      setActiveFilter('ALL');
    } else {
      setActiveFilter(filterKey);
    }
  }

  function handleSelectProspect(prospect) {
    setSelectedProspect(prospect);
  }

  return (
    <div className="pp__page">
      <ProspectStatsStrip
        stats={stats}
        loading={loadingStats}
        activeFilter={activeFilter}
        onTileClick={handleTileClick}
      />

      <div className="pp__split">
        {loadingProspects ? (
          <div className="pp__loading">Loading prospects...</div>
        ) : (
          <ProspectNavPanel
            prospects={prospects}
            activeFilter={activeFilter}
            onFilterChange={handleFilterChange}
            selectedId={selectedProspect ? selectedProspect.id : null}
            onSelect={handleSelectProspect}
          />
        )}

        <ProspectWorkspace prospect={selectedProspect} />
      </div>
    </div>
  );
}
